import { type ComponentPropsWithoutRef, type ElementType, type ReactElement } from 'react'
import { CardMedia, type CardMediaProps } from '@mui/material'

import { type MediaRadius, type MediaRatio } from '@DS/components/components/media/atoms/media/Media.types'

import * as styles from './styles'

type MediaProps<Component extends ElementType> = CardMediaProps<Component> & {
  component?: Component
  fit?: 'contain' | 'cover'
  radius?: MediaRadius
  ratio?: MediaRatio
} & ComponentPropsWithoutRef<Component>

const Media = <Component extends ElementType>({
  fit = 'contain',
  radius = 'without',
  ratio,
  ...rest
}: MediaProps<Component>): ReactElement | null => {
  const component = rest.component || 'img'
  const isImage = component === 'img'
  const isVideo = component === 'iframe'

  return (
    <CardMedia
      {...rest}
      component={component}
      {...(isImage && !rest.alt && { alt: '' })}
      css={[isImage && styles.image(fit, ratio), isVideo && styles.video, styles.getRadius(radius)]}
    />
  )
}

export default Media
